'use strict'

export default (mockAxios) => {
  mockAxios.onGet(`/info-messages/top`).reply(200, {
    'success': true,
    'data': [
      {
        'id': '1j904odnk2qq',
        'type': 'T',
        'function': '3',
        'message': '同一人物判定をしてください',
        'unread': '1',
        'lang_function': '同一人物判定',
        'updated': '2018/01/01 00:00'
      }
    ],
    'pagination': {
      'page_count': 5,
      'current_page': 1,
      'has_next_page': true,
      'has_prev_page': false,
      'count': 55,
      'limit': 10
    }
  })

  // 一覧
  mockAxios.onGet(`/info-messages`).reply(200, {
    'success': true,
    'data': [
      {
        'id': '1j904odnk2qo',
        'type': 'T',
        'function': '3',
        'message': '同一人物判定をしてください',
        'unread': '1',
        'lang_function': '同一人物判定',
        'updated': '2018/01/01 00:00'
      },
      {
        'id': '1j904odnk2qp',
        'type': 'T',
        'function': '2',
        'message': '読取不能の名刺がありました。',
        'unread': '1',
        'lang_function': '修正サービス',
        'updated': '2018/01/01 00:00'
      },
      {
        'id': '1j904odnk2qr',
        'type': 'I',
        'function': '4',
        'message': '名刺交換者に指定されました。',
        'unread': '1',
        'lang_function': '名刺登録更新',
        'updated': '2018/01/01 00:00'
      },
      {
        'id': '1j904odnk2qs',
        'type': 'I',
        'function': '4',
        'message': '名刺が統合されました。',
        'unread': '1',
        'lang_function': '名刺登録更新',
        'updated': '2018/01/01 00:00'
      },
      {
        'id': '1j904odnk2qt',
        'type': 'I',
        'function': '3',
        'message': '同一人物判定により個人的なメモが統合されました',
        'unread': '1',
        'lang_function': '同一人物判定',
        'updated': '2018/01/01 00:00'
      },
      {
        'id': '1j904odnk2qu',
        'type': 'I',
        'function': '5',
        'message': 'Sales Force Assistantへの連携が成功しました。',
        'unread': '1',
        'lang_function': 'Sales Force Assistant連携',
        'updated': '2018/01/01 00:00'
      },
      {
        'id': '1j904odnk2qv',
        'type': 'E',
        'function': '5',
        'message': 'Sales Force Assistantへの連携がタイムアウトしました。',
        'unread': '1',
        'lang_function': 'Sales Force Assistant連携',
        'updated': '2018/01/01 00:00'
      },
      {
        'id': '1j904odnk2qw',
        'type': 'E',
        'function': '5',
        'message': 'Sales Force Assistantへの連携が失敗しました。',
        'unread': '1',
        'lang_function': 'Sales Force Assistant連携',
        'updated': '2018/01/01 00:00'
      }
    ],
    'pagination': {
      'page_count': 5,
      'current_page': 1,
      'has_next_page': true,
      'has_prev_page': false,
      'count': 55,
      'limit': 10
    }
  })

  // お知らせ取得
  mockAxios.onGet(new RegExp(`/info-messages/\\d+`)).reply(200, {
    'success': true,
    'data': {
      'id': '1j904odnk2qq',
      'type': 'T',
      'function': '3',
      'sid_data': 1,
      'message': '同一人物判定をしてください',
      'msgdetail': 'あなたが保有する名刺の人物と同一と思われる人物が検出されました。同一人物判定を行ってください\n検出された名刺の姓名: 芽石 番玖 さん',
      'msgdetailsp': 'あなたが保有する名刺の人物と同一と思われる人物が検出されました。PCブラウザ版の画面にて同一人物判定を行なってください。\n検出された名刺の姓名: 芽石 番玖 さん',
      'unread': '1',
      'lang_function': '同一人物判定',
      'updated': '2018/01/01 00:00'
    }
  })

  // 既読
  mockAxios.onPut(new RegExp(`/info-messages/\\d+`)).reply(201, {
    'success': true,
    'data': []
  })

  // 削除
  mockAxios.onDelete(new RegExp(`/info-messages/\\d+`)).reply(200, {
    'success': true,
    'data': []
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/infoRepositoryMock.js